export const skills = [
  "Apache Airflow", "Apache Iceberg", "Spark (PySpark)", "Python",
  "Django", "REST APIs", "Distributed Systems",
  "Kafka", "AWS (Lambda, SQS, ECS, EC2)", "Docker", "Microservices",
  "MongoDB", "Redis", "Elasticsearch", "Grafana", "ELK Stack",
  "SQL", "MySQL", "NoSQL", "FastAPI", "Flask",
  "Web Scraping", "Crawlers", "Git", "GitHub", "BitBucket",
  "Java", "C++", "C Language"
];
